import { FC, ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';

type HtmlEditorPortalProps = {
  children: ReactNode;
};

export const HtmlEditorPortal: FC<HtmlEditorPortalProps> = ({ children }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return createPortal(children, document.body);
};
